// This file is used for displaying the full forms of the project tags in project card

export const projectTags: any = {
  "DevOPS and Infrastructure Tool (DO)": "DO",
  "Language & Framework (L&F)": "L&F",
  "Application (A)": "A",
  "Distributed & Decentralized Application (DA)": "DA",
  "Open Source Security Tool (S)": "S",
  "Security Risk Management (SD-SRM)": "SD-SRM",
  "Application Security (SD-AS)": "SD-AS",
  "Data Security (SD-DS)": "SD-DS",
  "Infrastructure Security (SD-IS)": "SD-IS",
  "Security Operations (SD-SOC)": "SD-SOC",
  "Identiry Access Management (SD-IAM)": "SD-IAM",
  "Cloud Security (SD-CS)": "SD-CS",
  "Blockchain Security (SD-BS)": "SD-BS",
  "Network Security (SD-NS)": "SD-NS",
  "IOT/OT Security (SD-IoTS)": "SD-IoTS",
  "Cryptography (SD-Crypto)": "SD-Crypto",
  "Web Development (TD-U-W)": "TD-U-W",
  "Artifical Intelligence / Machine Learning (TD-U-AI/ML)": "TD-U-AI/ML",
  "Database (TD-U-Db)": "TD-U-Db",
  "Messaging (TD-U-Msg)": "TD-U-Msg",
  "API Development (TD-U-ApD)": "TD-U-ApD",
  "Mobile Application (TD-U-MoA)": "TD-U-MoA",
  "Desktop Application (TD-U-DkA)": "TD-U-DkA",
  "Data Analytics (TD-U-DAA)": "TD-U-DAA",
  "IoT (TD-U-IoT)": "TD-U-IoT",
  "Blockchain (TD-U-Bln)": "TD-U-Bln",
  "Industry - Bank & Financial Institutions (BFSI)": "BFSI",
  "Industry - Healthcare & Life Scienses (HLS)": "HLS",
  "Industry - Consumer (CON)": "CON",
  "Industry - Retail (RT)": "RT",
  "Industry - Agritech (AgT)": "AgT",
  "Industry - Education (ED)": "ED",
  "Industry - Non Profit & Govt (NG)": "NG",
  "Industry - Energy & Utilities (ENU)": "ENU",
  "Industry - All (ALL)": "ALL",
  "Industry - Automotive (AM)": "AM",
  "Industry - Telecom (TEL)": "TEL",
  "Cybersecurity (CyS)": "CyS",
  "Client Application (TD-C-CA)": "TD-C-CA",
  "Server (TD-C-S)": "TD-C-S",
  "Web Application (TD-C-WA)": "TD-C-WA",
  "API clients (TD-C-A)": "TD-C-A",
  "Database (TD-C-D)": "TD-C-D",
  "Messaging (TD-C-M)": "TD-C-M",
  "Distributed Application (TD-C-DA)": "TD-C-DA",
  "Microservices (TD-C-Ms)": "TD-C-Ms",
  "Container (TD-C-C)": "TD-C-C",
  "Wallet App (TD-C-Wlt)": "TD-C-Wlt",
  "Foundation led projects (COM-F)": "COM-F",
  "Community led projects (COM-C)": "COM-C"
};
